import { useMutation, useQueryClient } from "@tanstack/react-query";

import { saveOverride } from "./api";
import type { SavePromptResponse } from "./api";

// Сохранение ручного override промпта (source=manual,
// edited_by=principal на backend). На успех инвалидируем весь префикс
// `agent-roles` — список (новый badge override), detail (новый
// effective_system_prompt) и история (новая строка override'а)
// перечитаются. Ошибку (404 нет роли / 422 пустой промпт) пробрасываем
// для тоста.
interface SaveOverrideArgs {
  readonly roleName: string;
  readonly promptText: string;
}

export function useSaveOverride(): ReturnType<
  typeof useMutation<SavePromptResponse, Error, SaveOverrideArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<SavePromptResponse, Error, SaveOverrideArgs>({
    mutationFn: (args) => saveOverride(args.roleName, args.promptText),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agent-roles"] });
    },
  });
}
